import { format, parseISO } from 'date-fns';
import { useQuery } from 'react-query';

import { userApi } from '@/services';

const useQueryCalendar = (projectId = undefined) => {
  return useQuery(
    ['getAppointment', projectId && projectId],
    async () => {
      try {
        const {
          data: { data },
        } = await userApi.get('/calendar', {
          params: {
            ...(projectId ? { pid: projectId } : {}),
          },
        });

        const appointment = data.map(
          ({
            title,
            id,
            translated_date_to: translatedDateTo,
            time_to: time,
            datetime_to_ms: timems,
            date_to: dateTo,
            fk_subtask: subtask,
            fk_task: task,
            status,
            path,
          }) => {
            return {
              title,
              id,
              translatedDateTo,
              time,
              timems,
              date: format(new Date(dateTo), 'yyyy-MM-dd'),
              subtask,
              task,
              status,
              ...path,
            };
          }
        );

        return {
          data,
          appointment,
          listAllAppointment: appointment.map((v) => {
            return {
              ...v,
              date: parseISO(v.date).getTime(),
            };
          }),
        };
      } catch (e) {
        throw new Error(e.message);
      }
    },
    { keepPreviousData: true }
  );
};

export default useQueryCalendar;
